<template>
  <Teleport to="body">
    <div
      v-if="show"
      class="modal fade show d-block"
      tabindex="-1"
      style="background-color: rgba(0, 0, 0, 0.5)"
      @click.self="close"
    >
      <div class="modal-dialog modal-lg modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Security Warnings - {{ dependency?.name }} ({{ dependency?.current_version }})</h5>
            <button type="button" class="btn-close" @click="close" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="alert alert-danger">
              <strong>CVSS v3 Score:</strong> {{ dependency?.cvss_v3_score ?? "N/A" }}
            </div>
            <pre class="security-warnings-content">{{ dependency?.security_warnings }}</pre>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="close">Close</button>
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
const props = defineProps({
  show: {
    type: Boolean,
    required: true
  },
  dependency: {
    type: Object,
    default: null
  }
});

const emit = defineEmits(["close"]);

const close = () => {
  emit("close");
};
</script>

<style scoped>
.security-warnings-content {
  white-space: pre-wrap;
  word-wrap: break-word;
  font-size: 0.9rem;
}
</style>
